import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseEntityService } from 'src/app/shared/services/base-entity.service';
import { environment } from 'src/environments/environment';
import { CalculationResult, calculationResultFactory } from '../models/calculation-result';
import Response = ZoningAPI.Response;
import * as _ from 'lodash';

const API_ENDPOINT = environment.ZONAR_API_URL + '/calculation-result';

@Injectable({
    providedIn: 'root'
})
export class CalculationResultService extends BaseEntityService<CalculationResult> {
    constructor(private readonly http: HttpClient) {
        super(calculationResultFactory);
    }

    updateCRs(state_env: string, zcVersionId: number, lastUpdated: string): Observable<number> {
        if (!state_env || !zcVersionId || !lastUpdated) {
            return of(null);
        }
        const params = new HttpParams({
            fromObject: {
                state_env
            }
        });
        return this.http.patch<Response>(`${API_ENDPOINT}`, { zcVersionId, lastUpdated }, { params }).pipe(
            map(response => {
                return _.get(response, 'data.updatedCRs', 0) as number;
            })
        );
    }
}
